<template>
  <!-- 承载二维码容器 -->
  <div class="wx_dialog_toiast_delltet" id="login_container">
    <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
      <i class="el-icon-close" style="font-size: 26px"></i>
    </div>
  </div>
</template>
<script>
import { doLogin } from "@/api/map/index";
export default {
  name: 'WeiXinLogin',

  data() {
    return {
      Wechat_authorized_login: false,
    };
  },
  created(){
    // 禁用浏览器返回键
    // history.pushState(null, null, document.URL);
    // window.addEventListener("popstate", this.disableBrowserBack);
  },
  mounted() {
    this.get_wx_qrcode();
  },

  methods: {
    //点击微信登陆
    wechatLogin() {
      this.Wechat_authorized_login = true
    },
    get_wx_qrcode() {
      //从微信的开发文档不难看出回调域名需要经过encodeURIComponent处理
      new WxLogin({
        self_redirect: false,  //值为true时，直接在二维码的弹窗中进行页面跳转及其余操作,
        id: "login_container",       //需要承载二维码的容器id  
        appid: "wx2d08e474087bd755",
        scope: "snsapi_login",     //网页授权，目前网页只有这一种方式，静默授权 encodeURIComponent('http://www.baoxiu.cn/#/bindAccount'),
        redirect_uri: encodeURIComponent('http://hanyuan.fengrenkeji.cn:9003/hanyuanMap.html#/LoginSuccess'),     //回调域名(地址前部分是项目域名，后部分loginSuccess是微信需要跳转的路径（vue中的路由名称）)
        state: Math.random(),
        style: "black",
        href: "",
      });
    },
    close_wchat_qrcode() {
      this.Wechat_authorized_login = false;
      this.get_wx_qrcode();
    },
    // 禁用浏览器返回操作
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
    // toLogin() {
    //   doLogin().then((res) => {
    //     console.log('登录返回值：', res)
    //   })
    // }
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    // window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from,'##')
    localStorage.setItem('fromPath', from.fullPath)
    // if(token){
    //   next({ path: '/' });
    // }else{
    next()
    // }
  }
};
</script>
<style scoped>
.wx_dialog_toiast {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9854647;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wx_dialog_toiast_delltet {
  width: 500px;
  height: 500px;
  margin: 0 auto;
  margin-top: 50px;
}

.wx_dialog_button_delete {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>